import React from "react";
import { Col, Row } from "antd";

// Prefijo propio "evp-" para no chocar con otros módulos
export const STYLES = `
  @keyframes evpFadeUp {
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .evp-header { margin-bottom: 18px; animation: evpFadeUp 0.45s cubic-bezier(0.22,1,0.36,1) both; }
  .evp-eyebrow {
    display: flex; align-items: center; gap: 10px;
    font-size: 10.5px; font-weight: 700; letter-spacing: 0.14em;
    text-transform: uppercase; color: #7c3aed; margin-bottom: 6px;
  }
  .evp-eyebrow-bar { display: inline-block; width: 24px; height: 2.5px; background: #7c3aed; border-radius: 4px; flex-shrink: 0; }
  .evp-title { font-size: 22px; font-weight: 700; color: #0f172a; margin: 0 0 2px; letter-spacing: -0.02em; line-height: 1.2; }
  .evp-subtitle { font-size: 12.5px; color: #94a3b8; font-weight: 500; margin: 0; }

  .evp-filtros { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 14px; padding: 14px 18px; margin-bottom: 16px; }

  .evp-kpi {
    background: #ffffff; border: 1px solid #e2e8f0; border-radius: 14px;
    padding: 14px 16px 12px; box-shadow: 0 1px 4px rgba(0,0,0,0.05), 0 4px 16px rgba(0,0,0,0.04);
    opacity: 0; animation: evpFadeUp 0.5s cubic-bezier(0.22,1,0.36,1) both; height: 100%;
  }
  .evp-kpi-accent { height: 3px; width: 32px; border-radius: 3px; margin-bottom: 10px; }
  .evp-kpi-label { font-size: 9.5px; font-weight: 800; letter-spacing: 0.11em; text-transform: uppercase; color: #94a3b8; margin-bottom: 4px; }
  .evp-kpi-value { font-size: 24px; font-weight: 700; letter-spacing: -0.02em; line-height: 1.1; }
  .evp-kpi-hint { font-size: 10.5px; color: #94a3b8; font-weight: 500; margin-top: 2px; }

  .evp-card {
    background: #ffffff; border: 1px solid #e2e8f0; border-radius: 16px;
    padding: 18px 20px 14px; box-shadow: 0 1px 4px rgba(0,0,0,0.05), 0 4px 16px rgba(0,0,0,0.04);
    opacity: 0; animation: evpFadeUp 0.55s cubic-bezier(0.22,1,0.36,1) both; height: 100%; margin-bottom: 16px;
  }
  .evp-card-label { font-size: 9.5px; font-weight: 800; letter-spacing: 0.13em; text-transform: uppercase; color: #7c3aed; margin-bottom: 2px; }
  .evp-card-title { font-size: 15px; font-weight: 700; color: #1e293b; margin: 0; letter-spacing: -0.01em; }
  .evp-card-accent { height: 3px; width: 40px; border-radius: 3px; margin: 8px 0 14px; background: linear-gradient(90deg, #7c3aed, #a78bfa); }

  .evp-tabla { width: 100%; border-collapse: collapse; font-size: 12.5px; }
  .evp-tabla th, .evp-tabla td { border: 1px solid #e2e8f0; padding: 6px 8px; text-align: center; }
  .evp-tabla th { background: #f8fafc; color: #64748b; font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.05em; }
  .evp-tabla td.evp-sindatos { color: #cbd5e1; }

  .evp-vacio { background: #ffffff; border: 1px dashed #cbd5e1; border-radius: 16px; padding: 44px 24px; text-align: center; }
  .evp-vacio-titulo { font-size: 15px; font-weight: 700; color: #1e293b; margin-bottom: 4px; }
  .evp-vacio-texto { font-size: 12.5px; color: #94a3b8; }
`;

export const NIVO_THEME = {
  background: "transparent",
  text: { fill: "#94a3b8", fontSize: 10.5 },
  grid: { line: { stroke: "#f1f5f9", strokeWidth: 1 } },
  axis: { ticks: { text: { fill: "#94a3b8", fontSize: 10 } } },
  tooltip: {
    container: {
      background: "#ffffff",
      color: "#1e293b",
      border: "1px solid #e2e8f0",
      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
      borderRadius: 10,
      fontSize: 12,
    },
  },
};

export const colorPorcentaje = (p) => (p == null ? "#cbd5e1" : p >= 90 ? "#10b981" : p >= 70 ? "#f59e0b" : "#ef4444");

export const HeaderReporte = ({ eyebrow, titulo, subtitulo }) => (
  <div className="evp-header">
    <div className="evp-eyebrow">
      <span className="evp-eyebrow-bar" />
      {eyebrow}
    </div>
    <h1 className="evp-title">{titulo}</h1>
    {subtitulo && <p className="evp-subtitle">{subtitulo}</p>}
  </div>
);

export const KpiRow = ({ items = [], style }) => {
  const visibles = items.filter(Boolean);
  if (visibles.length === 0) return null;
  const span = Math.max(4, Math.floor(24 / Math.min(visibles.length, 6)));

  return (
    <Row gutter={[12, 12]} style={{ marginBottom: 16, ...style }}>
      {visibles.map((item, i) => (
        <Col key={item.key} xs={12} sm={8} md={item.span ?? span}>
          <div className="evp-kpi" style={{ animationDelay: `${0.04 * i}s` }}>
            <div className="evp-kpi-accent" style={{ background: item.color }} />
            <div className="evp-kpi-label" title={item.label}>{item.label}</div>
            <div className="evp-kpi-value" style={{ color: item.color }}>{item.value}</div>
            {item.hint && <div className="evp-kpi-hint">{item.hint}</div>}
          </div>
        </Col>
      ))}
    </Row>
  );
};

export const ChartCard = ({ label, titulo, altura = 320, children }) => (
  <div className="evp-card">
    <div className="evp-card-label">{label}</div>
    <h2 className="evp-card-title">{titulo}</h2>
    <div className="evp-card-accent" />
    <div style={{ height: altura }}>{children}</div>
  </div>
);

export const EstadoVacio = ({ titulo, texto }) => (
  <div className="evp-vacio">
    <div className="evp-vacio-titulo">{titulo}</div>
    <div className="evp-vacio-texto">{texto}</div>
  </div>
);
